<template>
  <div>
    <keep-alive>
      <router-view>
      </router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'component-board',
  methods: {
    playContent (content) {
      this.$router.push({
        name: content,
      })
      // this.saveRouter();
    },
    saveRouter () {
      sessionStorage.setItem('router', this.$route.path);
    },
    autoSelectRouter () {
      if (sessionStorage.getItem('router') && sessionStorage.getItem('router') != '/index') {
        this.$bus.$on('playContent', sessionStorage.getItem('router'));
      }
      else {
        this.$router.push({
          name: 'index'
        })
      }
    }
  },
  mounted () {
    this.$router.push({
      name: 'index'
    })
    this.$bus.$on('playContent', this.playContent);
    this.$bus.$on('showMiniList', () => {
      this.$router.push({
        name: 'index',
      })
      // this.saveRouter();
    })
    // this.autoSelectRouter();
  },
  beforeDestroy () {
    this.$bus.$off('playContent');
    this.$bus.$off('showMiniList');
  }
}
</script>

<style>
</style>